import { ArslActionLoadData, ArsListingState } from "../interface";
import { datasetsFromColumns } from "./datasetsFromColumns";

/**
 * Replaces the current listing body data from a load action.
 *
 * @param state - Current ARS listing state
 * @param action - Load-data action containing the new body data
 * @returns Updated ARS listing state with the loaded body data
 */
export const arsl_loadData = <T>(
  state: ArsListingState<T>,
  action: ArslActionLoadData<T>,
): ArsListingState<T> => ({
  ...state,
  bodyData: action.bodyData,
  datasets: datasetsFromColumns(action.bodyData.arsListingColumns),
  changed: false,
});
